export default __webpack_public_path__ + "media/images/banners/bnr_1week-f0a222ad3da6331090bbc206b6cdc454.jpg";